/**
 * Tab List Component Exports
 *
 * @since 1.0.0
 */

export { PageList } from './component';
